import { render, staticRenderFns } from "./ParticipantHistory.vue?vue&type=template&id=16caeac0&"
import script from "./ParticipantHistory.vue?vue&type=script&lang=ts&"
export * from "./ParticipantHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports